import {
	Button,
	SxProps,
	Theme,
} from "@mui/material";
import React from "react";
import { useIntl } from "react-intl";

export const FindTableButton = ({
	handleFindTable,
	styles,
	disabled,
}: {
	handleFindTable: () => void;
	styles: SxProps<Theme>;
	disabled: boolean;
}) => {
	const { formatMessage } = useIntl();

	return (
		<Button
			variant="contained"
			disabled={disabled}
			sx={styles}
			onClick={handleFindTable}
		>
			{formatMessage({
				id: "steps.FindTable",
				defaultMessage: "Encontrar mesa",
			})}
		</Button>
	);
};